import InputComponent from 'components/inputComponent';
import Alert from 'components/alertComponent';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { exact6DigitsPattern } from '../../../../../../utilities/variables';
import { VERIFICATION_CODE_LENGTH } from '../../../../../../utilities/constants/mfa';
import { normalizePhoneNumber } from '../../../../../../utilities/functions';
import ButtonComponent from '../../../../../../components/button/buttonComponent';
import React from 'react';

interface PasswordChangeVerificationProps {
  onCodeChange: (code: string) => void;
  mfaError: string;
  codeError?: string;
  timer?: number;
  codeBlur?: () => void;
  handleResendCode?: () => void;
  disableResendActions?: boolean;
  code?: string;
}

export const PasswordChangeVerification: React.FC<
  PasswordChangeVerificationProps
> = ({
  onCodeChange,
  mfaError,
  codeBlur,
  codeError,
  handleResendCode,
  timer,
  disableResendActions,
  code,
}) => {
  const { data: locale, loading: loading } = useGetPage({
    locale: 'en',
    pageId: pageIds.VERIFICATION,
  });

  if (loading && !locale) return null;

  return (
    <div className="flex flex-col gap-[30px]">
      {mfaError && <Alert type="warning" text={mfaError} />}
      <p className="text-med-gray">{locale.descriptions}</p>

      <div>
        <label
          className="font-base font-semibold text-dark-gray"
          htmlFor="Verification code"
        >
          {locale.verificationCodeLabel}
          <span className="text-clc-red">*</span>
        </label>

        <div>
          <InputComponent
            testID="verification-code-input"
            type="text"
            name="Verification Code"
            pattern={exact6DigitsPattern}
            maxLengthValue={VERIFICATION_CODE_LENGTH}
            onChange={(e) => onCodeChange(normalizePhoneNumber(e.target.value))}
            value={code}
            errorStatus={!!codeError}
            errorMsgWithIcon={codeError}
            noMarginBottom
            onBlur={codeBlur}
            placeholder={locale.inputPlaceholder}
          />
        </div>

        <div className="flex mt-4 w-full justify-center desktop:mx-auto">
          <span className="text-med-gray mr-2">{locale?.resendLabel}</span>
          <ButtonComponent
            onClick={handleResendCode}
            type="underline"
            testID={'resend-again-code'}
            disabled={disableResendActions}
          >
            {locale?.resendButton}
          </ButtonComponent>
          {disableResendActions && <span className="ml-2">{timer}</span>}
        </div>
      </div>
    </div>
  );
};
